const getters = {
  dialogInteressado: (state) => state.dialogInteressado,
  dialogResponsavelTramitacao: (state) => state.dialogResponsavelTramitacao,
  tipoInteressado: (state) => state.tipoInteressado,
  interessado: (state) => state.interessado,
  tipoResponsavelTramitacao: (state) => state.tipoResponsavelTramitacao,
  responsavelTramitacao: (state) => state.responsavelTramitacao,
  listaTiposDocumento: (state) => state.listaTiposDocumento,
  listaTiposInteressado: (state) => state.listaTiposInteressado,
  listaEntidadeInteressada: (state) => state.listaEntidadeInteressada,
  listaEntidadeResponsavelTramitacao: (state) => state.listaEntidadeResponsavelTramitacao,
  listaInteressados: (state) => state.listaInteressados,
  listaDocumentos: (state) => state.listaDocumentos,
  listaUnidadesProcedencia: (state) => state.listaUnidadesProcedencia,
  buscandoDocumentos: (state) => state.buscandoDocumentos
}

export default getters
